import { format, unwrapFunctionStore } from 'svelte-i18n';

const $format = unwrapFunctionStore(format);

export const creatingSignature = {
  popover: {
    title: $format('label.TOURS.STUDIO.CREATE.CREATING_SIG.TITLE'),
    description: $format('label.TOURS.STUDIO.CREATE.CREATING_SIG.DESCRIPTION')
  }
};
